import styled from "styled-components";
import { colors } from "utils";

/**
 * The BETA tag on the Student Reports nav item and page heading (D48.17).
 *
 * Not the existing `<Tag>`: that one ships a hover bubble at a fixed size and
 * is used on page HEADINGS, so dropping it into a narrow nav item is a visual
 * judgement rather than a drop-in. This is the small, quiet form.
 */
export const BetaBadge = styled.span`
  background-color: ${colors.yellow100 || "#FFFACF"};
  color: ${colors.nightlyWoods900};
  font-family: "Inter", sans-serif;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.06em;
  line-height: 1.4;
  padding: 1px 5px;
  border-radius: 3px;
  margin-left: 6px;
`;

/**
 * The page heading's BETA: the frames' "Tag - Beta" (3083:19525), a pink pill
 * beside the 40px title. The quiet form above stays on the nav item, where a
 * pill this size would crowd the label.
 */
export const HeadingBetaBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 200px;
  background-color: #d91a6c;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0;
`;
